// languages/en.js
export const en = {
  // UI Text
  ui: {
    title: "Haunted House of Dark Data",
    subtitle: "An interactive journey through the problems of unused enterprise data",
    blogReference: "Based on the FELD M",
    blogLinkText: "blog article",
    blogLinkSuffix: "about Dark Data",
    loadingNextRoom: "Loading next room...",
    roomLoading: "Room loading...",
    restartGame: "Explore the haunted house again",
    backButton: "Back",
    language: "Language",
    visitFeldM: "Visit FELD M",
    learnMore: "Learn more"
  },

  // Ending Messages
  endings: {
    success: {
      title: "Data Excellence Achieved!",
      message: "Congratulations! You've recognized that clear use cases are the key to avoiding Dark Data. With concrete business questions and strategic data utilization, you transform your data house into a value-creating resource."
    },
    failure: {
      title: "Data Disaster!",
      message: "Your hasty actions have led to data loss or incalculable risks. Dark Data requires a thoughtful strategy, not hasty solutions."
    },
    awareness: {
      title: "Awareness Created",
      message: "You've recognized the true costs of Dark Data. This insight is the first step toward better Data Governance. Now you can develop a sustainable data strategy with FELD M."
    },
    neutral: {
      title: "The Journey Continues...",
      message: "Your tour through the Haunted House of Dark Data has shown how multi-layered and interconnected the challenges are. But now the crucial question arises: Where do you want to start to get your data house under control?"
    }
  },

  // Services
  services: {
    dataStrategy: {
      title: "Data Strategy & Governance",
      description: "Development of a sustainable data strategy with clear use cases"
    },
    dataArchitecture: {
      title: "Data Architecture",
      description: "Building robust data architectures for optimal data utilization"
    },
    dataGovernance: {
      title: "Data Governance",
      description: "Establishing processes and structures for control and security of your data assets"
    },
    dataEngineering: {
      title: "Data Architecture",
      description: "Support in conception as well as selection and deployment of necessary technologies."
    },
    dataAnalytics: {
      title: "Data Analytics & Insights",
      description: "Cost transparency and ROI evaluation of your data assets"
    },
    dataAssessment: {
      title: "Data Assessment",
      description: "Evaluation and inventory of your current data situation"
    },
    dataStrategyConsulting: {
      title: "Data Strategy Consulting",
      description: "Building roles, processes and rules for your data."
    },
    dataArchitectureConsulting: {
      title: "Data Architecture Consulting",
      description: "Support in selection, modernization and deployment of necessary technologies."
    }
  },

  // Company Info
  company: {
    helpTitle: "How FELD M can help you:",
    description: "With expertise in data strategy, data architecture and data governance, we ensure that your data is accessible, reliable and optimally utilized."
  },

  // Next Steps
  nextSteps: {
    title: "Possible next steps:",
    intro: "The most important step: collect and process data in high quality right from the start, supported by clear processes and responsibilities. The later quality issues are discovered and fixed, the more effort and cost they incur.",
    steps: {
      inventory: "Inventory your data & assign responsibilities: what exists, who owns it, and which regulations (GDPR, …) apply?",
      quality: "Measure & safeguard data quality: define KPIs (completeness, accuracy, …) and establish quality gates in the workflow.",
      prioritize: "Prioritize use cases: evaluate effort and benefit based on the inventory to move forward in a focused way.",
      pilot: "Launch a pilot project with clear success criteria: deliver value quickly, capture learnings, and plan scaling."
    }
  }
};